var map = {
	"./bg.json": [
		4746,
		746
	],
	"./cs.json": [
		3031,
		31
	],
	"./de.json": [
		3517,
		517
	],
	"./el.json": [
		2866,
		866
	],
	"./en.json": [
		1700,
		700
	],
	"./es.json": [
		6980,
		980
	],
	"./fr.json": [
		6493,
		493
	],
	"./hu.json": [
		6254,
		254
	],
	"./it.json": [
		7253,
		253
	],
	"./ja.json": [
		7842,
		842
	],
	"./nl.json": [
		5385,
		385
	],
	"./pl.json": [
		4112,
		112
	],
	"./pt.json": [
		4193,
		193
	],
	"./sk.json": [
		2241,
		241
	],
	"./sl.json": [
		2111,
		111
	],
	"./sr.json": [
		5377,
		377
	],
	"./zh.json": [
		5340,
		340
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7875;
module.exports = webpackAsyncContext;